var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('VueApexCharts',{attrs:{"width":"100%","height":"300","type":"bar","options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }